var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.387 8l3.142-3.142a.466.466 0 000-.658l-.73-.73a.466.466 0 00-.659 0L8 6.612 4.857 3.47a.466.466 0 00-.659 0l-.73.73a.466.466 0 000 .658L6.61 8l-3.142 3.142a.466.466 0 000 .658l.73.73a.466.466 0 00.659 0l3.142-3.142 3.141 3.142a.466.466 0 00.659 0l.73-.73a.466.466 0 000-.659L9.387 8z",
    fill: "#028BB7"
  })));
}

export default SvgCloseModalIcon;